export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_pusd-stake/artifacts/j6boimmk_palmentlogo%20%285%29.svg';

export const truncateAddress = (addr, pre = 4, post = 4) => {
  if (!addr) return '';
  const s = typeof addr === 'string' ? addr : addr.toString();
  if (s.length <= pre + post + 3) return s;
  return `${s.slice(0, pre)}…${s.slice(-post)}`;
};

export const fmtNum = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '0.00';
  const num = Number(n);
  if (Math.abs(num) >= 1_000_000)
    return (num / 1_000_000).toFixed(2) + 'M';
  if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(2) + 'K';
  return num.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtFull = (n, digits = 4) => {
  const num = Number(n) || 0;
  return num.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const timeAgo = (iso) => {
  const d = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - d);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const day = Math.floor(h / 24);
  return `${day}d ago`;
};
